module.exports = __webpack_public_path__ + "hbomaxar-static/media/CurvedScreen.08295073.fbx";